import { QuestionContextShape } from "types";
import { setupContext } from "context/useCSContext";

export const Context = setupContext<QuestionContextShape>("QuestionContext");
